<div *ngIf="quote" class="container-fluid cw-background mb-5 manage-view">
  <div class="row">
    <div class="col-12">
      <mat-card class="mat-elevation-z8 mt-3 pb-5" id="card">
        <!-- Header -->
        <div class="row">
          <div class="col-12 text-left go-back">
            <button (click)="onGoBack()" disableRipple mat-button class="p-0">
              <mat-icon matPreffix>arrow_back_ios</mat-icon>
              <span>Go Back</span>
            </button>
            <h6 class="card-title-page mt-2 mb-4">Edit Quote:</h6>
          </div>
        </div>
        <!-- Form -->
        <div class="row">
          <!-- Dynamic form -->
          <div class="col">
            <app-dynamic-form
              [questions]="questions"
              (formSubmit)="onUpdateQuote()"
              (hasChanged)="onChangeQuote($event)"
              [class]="null | applyFunctionOrReturn: getManageFormClass"
              [disabled]="!isEdit"
              [customBtn]="convertQuoteBtn"
            >
            </app-dynamic-form>
            <div class="text-center mt-2">
              <button
                *ngIf="currentUser.isGlobalAdmin()"
                (click)="onDeleteQuote()"
                disableRipple
                mat-button
                class="delete-quote"
              >
                <mat-icon matPreffix>delete</mat-icon>
                Delete quote
              </button>
            </div>
          </div>
          <!-- Version form -->
          <div class="col">
            <div class="row">
              <button
                *ngIf="
                  currentUser.isGlobal() &&
                    currentUser.hasRight(['admin', 'manager']) && { user: currentUser, quote: quote }
                    | applyFunctionOrReturn: canModifyAssets
                "
                (click)="onToggleManageQuote()"
                color="primary"
                mat-icon-button
                style="margin-left: 10px"
              >
                <mat-icon>create</mat-icon><span click class="mat-h3"> Edit</span>
              </button>
            </div>
          </div>
        </div>
        <!-- Tabs -->
        <div class="row mt-5">
          <div class="col-12">
            <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
              <mat-tab label="Assets">
                <app-data-table
                  [config]="assetsTableConfig"
                  (getData)="getQuotedAssets($event)"
                  (updateData)="updateQuotedAsset($event)"
                ></app-data-table>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
